import ButtonQuickText from "components/atoms/Button/Button.quickText";
import { autoCompleteState } from "modules/actions/autoComplete";
import { changeFontSize } from "modules/actions/fontSize";
import useRequestDM from "modules/hooks/useRequestDM";
import { disableAllMenu } from "modules/actions/statusMenu";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { chatList } from "modules/actions/chat";

/**
 * 하단의 메뉴 컴포넌트
 * @returns {object} ChatMenu
 */

const ChatMenu = ({ styleDef, viewStatus }) => {
  const currentFontSize = useSelector((state) => state.fontSize.size);
  const isActiveQuickMenu = useSelector((state) => state.isActive.quickMenu);

  const dispatch = useDispatch();

  const execOnSendMsg = (text) => {
    const paramSet = {
      inType: "query",
      inStr: text,
      inLabel: text,
      parameters: sessionStorage.getItem("address")
        ? {
            latitude_y: sessionStorage.getItem("latitude_y"),
            longitude_x: sessionStorage.getItem("longitude_x"),
            address: sessionStorage.getItem("address"),
            position_status: "Y",
          }
        : { latitude_y: "", longitude_x: "", position_status: "N" },
    };
    dispatch(chatList(paramSet));
    dispatch(disableAllMenu());
  };
  
  const onKeyPressEvt = (e) => {
    if (e.key === "Enter") {
      execOnSendMsg("처음으로");
    }
  };
  
  return (
    <div className="_quick_div" style={styleDef}>
      <div className="_quick_home" onClick={() => execOnSendMsg("처음으로")}>
        <button
          type="button"
          onClick={onKeyPressEvt}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="_quick_intro"
          aria-label="처음으로"
          title="처음으로" 
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/svg/returnHome.svg`}
            alt=""
            style={{ width: "18px" }}
          />
          <span>처음으로</span>
        </button>
      </div>
      <div className="_quick_menu">
        <ButtonQuickText
          label="민사"
          value="민사소송 안내"
          image={`${process.env.PUBLIC_URL}/images/svg/minsa.svg`}
          viewStatus=""
          styleDef={{}}
          onClickEvt={() => execOnSendMsg("민사소송 안내")}
          error={null}
          contentLength={8}
          ariaLabelText="민사 분야"
        />
        <ButtonQuickText
          label="형사"
          value="형사소송 안내"
          image={`${process.env.PUBLIC_URL}/images/svg/hyeongsa.svg`}
          viewStatus=""
          styleDef={{}}
          onClickEvt={() => execOnSendMsg("형사소송 안내")}
          error={null}
          contentLength={8}
          ariaLabelText="형사 분야"
        />
        <ButtonQuickText
          label="가사"
          value="가사소송 안내"
          image={`${process.env.PUBLIC_URL}/images/svg/gasa.svg`}
          viewStatus=""
          styleDef={{}}
          onClickEvt={() => execOnSendMsg("가사소송 안내")}
          error={null}
          contentLength={8}
          ariaLabelText="가사 분야"
        />
        <ButtonQuickText
          label="행정"
          value="행정소송 안내"
          image={`${process.env.PUBLIC_URL}/images/svg/haengjeong.svg`}
          viewStatus=""
          styleDef={{}}
          onClickEvt={() => execOnSendMsg("행정소송 안내")}
          error={null}
          contentLength={8}
          ariaLabelText="행정 분야"
        />
        <ButtonQuickText
          label="특허"
          value="특허소송 안내"
          image={`${process.env.PUBLIC_URL}/images/svg/teugheo.svg`}
          viewStatus=""
          styleDef={{}}
          onClickEvt={() => execOnSendMsg("특허소송 안내")}
          error={null}
          contentLength={8}
          ariaLabelText="특허 분야"
        />
        <ButtonQuickText
          label="개인파산/회생"
          value="개인파산/회생 안내"
          image={`${process.env.PUBLIC_URL}/images/svg/pasan.svg`}
          viewStatus=""
          styleDef={{}}
          onClickEvt={() => execOnSendMsg("개인파산/회생 안내")}
          error={null}
          contentLength={8}
          ariaLabelText="개인파산 회생 분야"
        />
        <ButtonQuickText
          label="강제집행"
          value="강제집행 안내"
          image={`${process.env.PUBLIC_URL}/images/svg/gangjejibhaeng.svg`}
          viewStatus=""
          styleDef={{}}
          onClickEvt={() => execOnSendMsg("강제집행 안내")}
          error={null}
          contentLength={8}
          ariaLabelText="강제집행 분야"
        />
        <ButtonQuickText
          label="신청"
          value="신청 절차 안내"
          image={`${process.env.PUBLIC_URL}/images/svg/sincheong.svg`}
          viewStatus=""
          styleDef={{}}
          onClickEvt={() => execOnSendMsg("신청 절차 안내")}
          error={null}
          contentLength={8}
          ariaLabelText="신청 분야"
        />
      </div>
    </div>
  );  
};
ChatMenu.propTypes = {
  styleDef: PropTypes.object,
  viewStatus: PropTypes.string
};
ChatMenu.defaultProps = {
  styleDef: {},
  viewStatus: ''
};
export default ChatMenu;
